/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Node_JoorInputs */

const en_node_joor = /** @type {(inputs: Node_JoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joor`)
};

/**
* | output |
* | --- |
* | "Joor" |
*
* @param {Node_JoorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const node_joor = /** @type {((inputs?: Node_JoorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Node_JoorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_node_joor(inputs)
});